// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1983": "1607dd98","5841": "52f0b707","8258": "1a8e11ce",}[chunkId] + ".css"
}